export enum DealOperationCategory {
  Tertiary = 'tertiary',
  Residential = 'residential',
  Ground = 'ground',
  Debt = 'debt'
}
export interface DealOperationCategoryData {
  label: string;
  value: DealOperationCategory;
}

export const DealOperationCategoriesArray : DealOperationCategoryData[] = [
  { label: 'Terciario', value: DealOperationCategory.Tertiary },
  { label: 'Residencial', value: DealOperationCategory.Residential },
  { label: 'Suelo', value: DealOperationCategory.Ground },
  { label: 'Deuda', value: DealOperationCategory.Debt },
];

export const getDealOperationCategoryLabel = (item: DealOperationCategory): string => (
  DealOperationCategoriesArray.find(c => c.value === item)?.label || ''
);
